import {NgModule} from "@angular/core";
import {ActivityComponent} from "./activity.component";
import {FaIconComponent, FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FeatherModule} from "angular-feather";
import {allIcons} from "angular-feather/icons";
import {MatCard, MatCardContent} from "@angular/material/card";
import {SchoolProgramTableModule} from "../school-program/school-program-table/school-program-table.module";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {CommonModule, NgForOf, NgIf} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
    SelectSchoolLevelRelationV2Module
} from "../../../shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module";
import {
    SelectYearLevelRelationV2Module
} from "../../../shared/modules/select-year-level-relation-v2/select-year-level-relation-v2.module";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatButtonModule} from "@angular/material/button";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgxPaginationModule} from "ngx-pagination";
import {
    SelectAcademicYearOnlyModule
} from "../../../shared/modules/select-academic-year-only/select-academic-year-only.module";
import {SelectSchoolModule} from "../../../shared/modules/select-school/select-school.module";
import {SelectSchoolActivityModule} from "../../../shared/modules/select-school-activity/select-school-activity.module";
import {SelectSchoolProgramModule} from "../../../shared/modules/select-school-program/select-school-program.module";
import {
    SelectSchoolProgramCategoryModule
} from "../../../shared/modules/select-school-program-category/select-school-program-category.module";
import {InputCheckboxModule} from "../../../shared/modules/input-checkbox/input-checkbox.module";
import {StatusNoDataModule} from "../../../shared/modules/status-no-data/status-no-data.module";
import {StatusLoadingModule} from "../../../shared/modules/status-loading/status-loading.module";
import {SelectPeriodModule} from "../../../shared/modules/select-period/select-period.module";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ActivityListComponent } from "./activity-list/activity-list.component";
import { ActivityAddComponent } from "./activity-add/activity-add.component";
import { ActivityRoutingModule } from "./activity-routing-module";
import { RouterModule } from "@angular/router";
import { ActivityEditComponent } from "./activity-edit/activity-edit.component";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import { PipeModule } from "src/shared/pipes/pipe.module";
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { TableParticipantComponent } from "../../../shared/modules/table-participant/table-participant.component";
import { RevoGrid } from '@revolist/angular-datagrid';
import { ActivityGridComponent } from './activity-grid/activity-grid.component';

@NgModule({
  declarations: [
      ActivityComponent,
      ActivityListComponent,
      ActivityAddComponent,
      ActivityEditComponent,
      ActivityGridComponent
  ],
    imports: [
        ActivityRoutingModule,
        RouterModule,
        FeatherModule.pick(allIcons),
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatRadioModule,
        MatButtonModule,
        MatCard,
        MatCardContent,
        MatTable,
        MatColumnDef,
        MatHeaderCell,
        MatCell,
        FaIconComponent,
        NgxDatatableModule,
        MatHeaderRow,
        NgxPaginationModule,
        MatRow,
        SelectAcademicYearOnlyModule,
        SelectSchoolModule,
        SelectSchoolLevelRelationV2Module,
        NgIf,
        MatHeaderRowDef,
        MatRowDef,
        MatHeaderCellDef,
        MatCellDef,
        NgForOf,
        MatPaginator,
        MatDatepickerModule,
        SelectSchoolActivityModule,
        SelectYearLevelRelationV2Module,
        SelectSchoolProgramModule,
        SelectSchoolProgramCategoryModule,
        InputCheckboxModule,
        StatusNoDataModule,
        StatusLoadingModule,
        SelectPeriodModule,
        MatTabGroup,
        MatTab,
        MatSlideToggle,
        NgSelectModule,
        MatInputModule,
        MatProgressSpinner,
        PipeModule,
        CommonModule,
        TableParticipantComponent,
        NgxMaskDirective,
        NgxMaskPipe,
        FontAwesomeModule,
        RevoGrid
    ],
    exports: [
        ActivityComponent
    ],
    providers: [
        provideNgxMask(),
    ]

})

export class ActivityModule {}
